import {
  Paginated,
  Pagination,
  PaginationQuery,
} from "@shared/services/common";

export interface LoadState<T> {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  errorObject?: Error;
  loaded: boolean;
  result?: T;
}

export interface PaginatedLoadState<T> {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  errorObject?: Error;
  loaded: boolean;
  result?: T;
  query?: any;
  page?: PaginationQuery;
  pagesTotal?: number;
  total?: number;
}

export interface PaginatedSearchState<Result, Query> {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  errorObject?: Error;
  loaded: boolean;
  result?: Result;
  query?: Query;
  page?: PaginationQuery;
  pagesTotal?: number;
  total?: number;
}

// NOTE: the difference to paginatedSearchState is that pagination here is flat, which is now the common return pattern
export interface SearchResponseState<Result, Query> {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  errorObject?: Error;
  loaded: boolean;
  result?: Result;
  query?: Query;
  page?: number;
  pageSize?: number;
  pagesTotal?: number;
  total?: number;
}

export const stateInitial: LoadState<any> = {
  loading: false,
  error: false,
  errorMessage: "",
  loaded: false,
  result: null,
};

export const stateLoading: LoadState<any> = {
  loading: true,
  error: false,
  errorMessage: "",
  loaded: false,
};

export const stateError: LoadState<any> = {
  loading: false,
  error: true,
  errorMessage: "",
  loaded: true,
};

export const stateLoaded: LoadState<any> = {
  loading: false,
  error: false,
  errorMessage: "",
  loaded: true,
};
